<template>
<div>
    <div class="location-info">
        <ResultsLocationTopValue :location="location" :rank="rank"/>
        <ResultsLocationAddress :location="location" :rank="rank"/>
        <ResultsBaseDistance :result="location" />
        <ResultsLocationSpecialties :location="location" :rank="rank" />
        <ResultsLocationAcceptingNewPatients :location="location" />
        <ResultsBaseCostRating :result="location" v-if="profile.showCostQuality"/>
        <ResultsBaseQualityRating :result="location" v-if="profile.showCostQuality" />
        <ResultsBaseLearnMoreLink :result="location" :rank="rank" />
        <ResultsLocationMakePrimaryClinic :location="location" :rank="rank" />
    </div>
    <hp5-spacing-vertical xs="sm" sm="sm" md="sm" lg="sm"></hp5-spacing-vertical>
    <div class="location-info-lower">
        <ResultsBasePhoneNumber :phoneNumber="appointmentNumber" :callNumber="number" :rank="rank"/>
        <ResultsLocationScheduleAppointment :location="location" :rank="rank"/>
        <ResultsBaseMapToggleButton class="toggle" :name="location.name" :rank="rank" v-on:toggle="onToggle" />
    </div>
    <div class="map-container">
        <ResultsLocationMap class="map" :location="location" :toggle="toggle" />
    </div>
</div>
</template>

<script setup>

    const props = defineProps({
        location: Object,
        rank: Number
    })

    const { profile } = useFCPModel()
    const toggle =ref(false)
    const appointmentNumber = computed(() => props.location.appointmentPhoneNumber )
    const number = computed(() =>
      props.location.appointmentPhoneNumber ? props.location.appointmentPhoneNumber.parenthesisStyleString.replaceAll(' ', '-') : null
    )

    const onToggle = (event) => toggle.value = !toggle.value

</script>

<style scoped lang="scss">

.location-info-lower{
  display: flex;

  .toggle {
    align-self: center;
  }
}

.map {
    margin-top: 18px;
    margin-left: -18px;
    margin-right: -18px;
    margin-bottom: -18px;
  }

</style>